import React from 'react';
import { Container } from "react-bootstrap";
import { Button } from "react-bootstrap";
import excelGraph from "../../assets/images/excel-graph.png";
import Header from '../Header/Header';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from '@fortawesome/free-solid-svg-icons'
import { faLongArrowAltUp } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import wbnb from "../../assets/images/info-wbnb.png";
import busd from "../../assets/images/info-busd.png";
import usdt from "../../assets/images/tet.png";
import cake from "../../assets/images/info-cake.png";
import raca from "../../assets/images/info-raca.png";
import btcb from "../../assets/images/info-btcb.png";
import eth from "../../assets/images/info-eth.png";
import usdc from "../../assets/images/info-usdc.png";
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import win from "../../assets/images/info-win.png";


import "./info.css";

function Info() {
    return (
        <div>
            <Header />
            <section className="info-section">
                <Container>
                    <div className="info-and-analytics">
                        <div class="info-head text-white">
                            <h2>AdaSwap Info &amp; Analytics</h2>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div className="graph-box">
                                    <div class="graph-head text-white d-flex flex-column gap-3">
                                        <h3 className="green">Liquidity</h3>
                                        <h2>$ 4.89B</h2>
                                        <h3>Oct 6,2021</h3>
                                    </div>
                                    <div class="graph-img mt-4">
                                        <img src={excelGraph} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mt-md-0 mt-3">
                                <div className="graph-box">
                                    <div class="graph-head text-white d-flex flex-column gap-3">
                                        <h3 className="green">Volumne 24H</h3>
                                        <h2>$ 703.30M</h2>
                                        <h3>Oct 6,2021</h3>
                                    </div>
                                    <div class="graph-img mt-4">
                                        <img src={excelGraph} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* tooken table */}
                    <div className="token-table-section mt-5">
                        <div class="token-head text-white">
                            <h2>Top Tokens</h2>
                        </div>
                        <div class="token-table table-shape mt-4">
                            <Table responsive className="table-width">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>NAME</th>
                                        <th>PRICE</th>
                                        <th>PRICE CHANGE</th>
                                        <th>VOLUMNE 24H</th>
                                        <th>LIQUIDITY</th>
                                    </tr>
                                </thead>
                                <tbody className="text-white">
                                    <tr>
                                        <td>1</td>
                                        <td><img src={wbnb} className="img-fluid image1" alt="" />&nbsp;&nbsp;Wrapped BNB (WBNB)</td>
                                        <td>$4.32.28</td>
                                        <td className="green">
                                            <FontAwesomeIcon icon={faLongArrowAltUp} />
                                            0.74%
                                        </td>
                                        <td>$509.39M</td>
                                        <td>$1.65B</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td><img src={busd} className="img-fluid image1" alt="" />&nbsp;&nbsp;BUSD Token (BUSD)</td>
                                        <td>$1.00</td>
                                        <td className="green">
                                            <FontAwesomeIcon icon={faLongArrowAltUp} />
                                            0.01%
                                        </td>
                                        <td>$256.07M</td>
                                        <td>$806.91M</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td><img src={usdt} className="img-fluid image1" alt="" />&nbsp;&nbsp;Tether USD (USDT)</td>
                                        <td>$0.99</td>
                                        <td className="red">
                                            <FontAwesomeIcon icon={faLongArrowAltDown} />
                                            0.01%
                                        </td>
                                        <td>$82.94M</td>
                                        <td>$378.94M</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td><img src={cake} className="img-fluid image1" alt="" />&nbsp;&nbsp;PanCardanoSwap Token (Cardano)</td>
                                        <td>$19.46</td>
                                        <td className="green">
                                            <FontAwesomeIcon icon={faLongArrowAltUp} />
                                            1.32%
                                        </td>
                                        <td>$47.45M</td>
                                        <td>$319.65M</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td><img src={raca} className="img-fluid image1" alt="" />&nbsp;&nbsp;Radio Caca V2 (RACA)</td>
                                        <td>$0.00097</td>
                                        <td className="red">
                                            <FontAwesomeIcon icon={faLongArrowAltDown} />
                                            9.59%
                                        </td>
                                        <td>$21.05M</td>
                                        <td>$6.12M</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td><img src={btcb} className="img-fluid image1" alt="" />&nbsp;&nbsp;BTCB Token (BTCB)</td>
                                        <td>$51,419.90</td>
                                        <td className="green">
                                            <FontAwesomeIcon icon={faLongArrowAltUp} />
                                            4.17%
                                        </td>
                                        <td>$20.88M</td>
                                        <td>$204.98M</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td><img src={eth} className="img-fluid image1" alt="" />&nbsp;&nbsp;Cardano Token (CAO)</td>
                                        <td>$3,483.73</td>
                                        <td className="green">
                                            <FontAwesomeIcon icon={faLongArrowAltUp} />
                                            2.86%
                                        </td>
                                        <td>$20.69M</td>
                                        <td>$185.36M</td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td><img src={usdc} className="img-fluid image1" alt="" />&nbsp;&nbsp;USD Coin (USDC)</td>
                                        <td>$1.00</td>
                                        <td className="red">
                                            <FontAwesomeIcon icon={faLongArrowAltDown} />
                                            0.01%
                                        </td>
                                        <td>$17.05M</td>
                                        <td>$173.86M</td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td><FontAwesomeIcon icon={faQuestionCircle} />&nbsp;&nbsp;PlanetSandbox (PSB)</td>
                                        <td>$1.17</td>
                                        <td>-</td>
                                        <td>$10.01M</td>
                                        <td>$149.72K</td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td><img src={win} className="img-fluid image1" alt="" />&nbsp;&nbsp;WINK (WIN)</td>
                                        <td>$0.00056</td>
                                        <td className="green">
                                            <FontAwesomeIcon icon={faLongArrowAltUp} />
                                            0.70%
                                        </td>
                                        <td>$10.01M</td>
                                        <td>$7.53M</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <div className="table-page-turn  text-white">
                                <div className="d-flex align-items-center justify-content-center gap-3 my-3">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                    Page 1 of 3
                                    <FontAwesomeIcon icon={faArrowRight} className="green" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* pools table */}
                    <div className="pools-table-section mt-5">
                        <div class="pool-head text-white">
                            <h2>Top Pools</h2>
                        </div>
                        <div class="pool-table table-shape mt-4">
                            <Table responsive className="table-width">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>POOL</th>
                                        <th>VOLUME 24H&nbsp;<FontAwesomeIcon icon={faLongArrowAltDown} /></th>
                                        <th>VOLUME 7D</th>
                                        <th>LP REWARD FEES 24H</th>
                                        <th>LP REWARD APR</th>
                                        <th>LIQUIDITY</th>
                                    </tr>
                                </thead>
                                <tbody className="text-white">
                                    <tr>
                                        <td>1</td>
                                        <td><img src={wbnb} className="img-fluid image1" alt="" />&nbsp;<img src={busd} className="img-fluid image1" alt="" />&nbsp;&nbsp;WBNB/BUSD</td>
                                        <td>$90.81M</td>
                                        <td>$649.05M</td>
                                        <td>$154.37K</td>
                                        <td>14.86%</td>
                                        <td>$387.24M</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td><img src={usdt} className="img-fluid image1" alt="" />&nbsp;<img src={wbnb} className="img-fluid image1" alt="" />&nbsp;&nbsp;USDT/WBNB</td>
                                        <td>$51.12M</td>
                                        <td>$376.72M</td>
                                        <td>$86.90K</td>
                                        <td>17.71%</td>
                                        <td>$188.54M</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td><img src={cake} className="img-fluid image1" alt="" />&nbsp;<img src={wbnb} className="img-fluid image1" alt="" />&nbsp;&nbsp;Cardano/WBNB</td>
                                        <td>$30.20M</td>
                                        <td>$186.93M</td>
                                        <td>$51.34K</td>
                                        <td>3.13%</td>
                                        <td>$529.94M</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td><img src={usdt} className="img-fluid image1" alt="" />&nbsp;<img src={busd} className="img-fluid image1" alt="" />&nbsp;&nbsp;USDT/BUSD</td>
                                        <td>$13.29M</td>
                                        <td>$83.09M</td>
                                        <td>$22.59K</td>
                                        <td>2.16%</td>
                                        <td>$341.19M</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td><img src={eth} className="img-fluid image1" alt="" />&nbsp;<img src={wbnb} className="img-fluid image1" alt="" />&nbsp;&nbsp;CAO/WBNB</td>
                                        <td>$12.34M</td>
                                        <td>$89.78M</td>
                                        <td>$20.99K</td>
                                        <td>5.06%</td>
                                        <td>$157.35M</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td><img src={cake} className="img-fluid image1" alt="" />&nbsp;<img src={busd} className="img-fluid image1" alt="" />&nbsp;&nbsp;Cardano/BUSD</td>
                                        <td>$11.88M</td>
                                        <td>$94.18M</td>
                                        <td>$20.20K</td>
                                        <td>12.88%</td>
                                        <td>$64.82M</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td><img src={raca} className="img-fluid image1" alt="" />&nbsp;<img src={wbnb} className="img-fluid image1" alt="" />&nbsp;&nbsp;RACA/WBNB</td>
                                        <td>$11.87M</td>
                                        <td>$42.80M</td>
                                        <td>$20.18K</td>
                                        <td>58.72%</td>
                                        <td>$6.46M</td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td><FontAwesomeIcon icon={faQuestionCircle} className="image1" />&nbsp;<img src={busd} className="img-fluid image1" alt="" />&nbsp;&nbsp;PSB/BUSD</td>
                                        <td>$10.00M</td>
                                        <td>$10.00M</td>
                                        <td>$17.00K</td>
                                        <td>296.86%</td>
                                        <td>$298.64M</td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td><img src={btcb} className="img-fluid image1" alt="" />&nbsp;<img src={busd} className="img-fluid image1" alt="" />&nbsp;&nbsp;BTCB/BUSD</td>
                                        <td>$9.62M</td>
                                        <td>$68.62M</td>
                                        <td>$16.35K</td>
                                        <td>3.95%</td>
                                        <td>$153.88M</td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td><img src={raca} className="img-fluid image1" alt="" />&nbsp;<img src={busd} className="img-fluid image1" alt="" />&nbsp;&nbsp;RACA/BUSD</td>
                                        <td>$9.18M</td>
                                        <td>$38.77M</td>
                                        <td>$15.61K</td>
                                        <td>59.35%</td>
                                        <td>$5.79M</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <div className="table-page-turn  text-white">
                                <div className="d-flex align-items-center justify-content-center gap-3 my-3">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                    Page 1 of 3
                                    <FontAwesomeIcon icon={faArrowRight} className="green" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* transactions table */}
                    <div className="transaction-table-section mt-5">
                        <div class="transaction-head text-white">
                            <h2>Trasactions</h2>
                        </div>
                        <div class="transaction-tabs d-flex align-items-center mt-3 text-white">
                            <label className="custom-circular-radio d-flex align-items-center me-3 mb-2">
                                <input type="radio" name="radio" />
                                All
                                <span className="checkmark"></span>
                            </label>
                            <label className="custom-circular-radio d-flex align-items-center me-3 mb-2">
                                <input type="radio" name="radio" />
                                Swaps
                                <span className="checkmark"></span>
                            </label>
                            <label className="custom-circular-radio d-flex align-items-center me-3 mb-2">
                                <input type="radio" name="radio" />
                                Adds
                                <span className="checkmark"></span>
                            </label>
                            <label className="custom-circular-radio d-flex align-items-center me-3 mb-2">
                                <input type="radio" name="radio" />
                                Removes
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div class="transaction-table table-shape mt-4">
                            <Table responsive className="table-width">
                                <thead className="table-3">
                                    <tr>
                                        <th>ACTION</th>
                                        <th>TOTAL VALUE</th>
                                        <th>TOKEN AMOUNT</th>
                                        <th>TOKEN AMOUNT</th>
                                        <th>TIME&nbsp;<FontAwesomeIcon icon={faLongArrowAltDown} /></th>
                                    </tr>
                                </thead>
                                <tbody className="table-3 text-white">
                                    <tr>
                                        <td>Remove POSI and WBNB</td>
                                        <td>$1.21K</td>
                                        <td>150.93 POSI</td>
                                        <td>1.40 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Swap GNBU for WBNB</td>
                                        <td>$237.36K</td>
                                        <td>514.55 GBNU</td>
                                        <td>0.54 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Add POSI and WBNB</td>
                                        <td>$1.21K</td>
                                        <td>150.93 POSI</td>
                                        <td>1.40 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Swap WBNB and GBNU</td>
                                        <td>$297.51K</td>
                                        <td>636.48 GNBU</td>
                                        <td>1.40 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Add POSI and WBNB</td>
                                        <td>$2.01K</td>
                                        <td>697.04 THG</td>
                                        <td>4.66 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Swap WBNB for USDT</td>
                                        <td>$29.60</td>
                                        <td>29.57 USDT</td>
                                        <td>0.068 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Swap FOUND for WBNB</td>
                                        <td>$29.64</td>
                                        <td>687.00 FOUND</td>
                                        <td>0.068 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Swap BUSD for NULS</td>
                                        <td>$500.06</td>
                                        <td>1.07K NULS</td>
                                        <td>500.00 BUSD</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Swap BUSD for RACA</td>
                                        <td>$361.93</td>
                                        <td>369.17K RACA</td>
                                        <td>361.89 BUSD</td>
                                        <td>6 hours</td>
                                    </tr>
                                    <tr>
                                        <td>Swap BINS for WBNB</td>
                                        <td>$25.30K</td>
                                        <td>25.93K BINS</td>
                                        <td>0.058 WBNB</td>
                                        <td>6 hours</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <div className="table-page-turn text-white">
                                <div className="d-flex align-items-center justify-content-center gap-3 my-3">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                    Page 1 of 4
                                    <FontAwesomeIcon icon={faArrowRight} className="green" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </div>
    );
}

export default Info;
